export type DisplayLocales = 'en' | 'es' | 'fr' | 'it' | 'de' | 'ja';
export type VoiceLocales = 'en-us' | 'es' | 'fr' | 'it' | 'de' | 'ja';

export type LocalizationModelKeys = keyof LocalizationModel;
interface LocalizationModel {
    display: DisplayLocales[];
    voice: VoiceLocales[];
}

export const locales: LocalizationModel = {
    display: ['en', 'es', 'fr', 'it', 'de', 'ja'],
    voice: ['en-us', 'es', 'fr', 'it', 'de', 'ja'],
};

export const dictationCommandsByLocale: { [key in VoiceLocales]: string[] } = {
    'en-us': ['type'],
    es: ['escribe'],
    fr: ['tape'],
    it: ['scrivi'],
    de: ['schreiben'],
    ja: ['書く'],
};

export const getLanguageOnly = (locale: string): string => {
    return locale.toLowerCase().split('-')[0];
};

/**
 * Gets the client supported and cultural fallback locale if supported
 * @param locale standard locale code
 * @param variant LocalizationModelKeys
 * @returns valid client string if there is a supported locale, otherwise returns null
 */
export const getSupportedLocale = (locale: string, variant: LocalizationModelKeys): string | null => {
    let result = null;
    if (locale) {
        const localeOptions: string[] = locales[variant];
        const localeLower = locale.toLowerCase();
        const languageOnly = getLanguageOnly(locale);

        if (localeOptions.includes(localeLower)) {
            result = localeLower;
        } else if (localeOptions.includes(languageOnly)) {
            result = languageOnly;
        } else if (localeLower.startsWith('en') && variant == 'voice') {
            result = 'en-us'; // exception for English Voice because the base is en-us
        }
    }

    return result;
};

export const getDefaultDictationCommands = (locale: string) => {
    const language = getSupportedLocale(locale, 'voice');

    let result = dictationCommandsByLocale['en-us'];
    if (language) {
        result = dictationCommandsByLocale[language as VoiceLocales];
    }

    return result;
};
